const activityRouter = {
  path: '/auth',
  redirect: '/auth/person',
  component: () => import('@/layout/orderHeader'),
  children: [
    {
      path: 'person',
      name: 'personAuth',
      meta: { title: '个人认证' },
      component: () => import(/* webpackChunkName: "auth" */ '@/pages/auth/person/index')
    },
    {
      path: 'companies',
      name: 'companyAuth',
      meta: { title: '企业认证' },
      component: () => import(/* webpackChunkName: "auth" */ '@/pages/auth/company/index'),
    },
    {
      path: 'companies/legalPerson',
      name: 'companyLegalPerson',
      meta: { title: '企业法人认证' },
      component: () => import(/* webpackChunkName: "auth" */ '@/pages/auth/company/legalPerson')
    },
    {
      path: 'companies/staff',
      name: 'companyStaff',
      meta: { title: '企业员工认证' },
      component: () => import(/* webpackChunkName: "auth" */ '@/pages/auth/company/staff')
    }
  ]
}

export default activityRouter
